var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,17.01v-2.01H21v2.01H3Zm0,2.99v-1.03H21v1.03H3Zm0-7.02v-2.99H21v2.99H3Zm0-8.98H21v4.02H3V4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStroke);
export default __webpack_public_path__ + "static/1788088179/media/icon-stroke.851ca82d84feb865d1a7d05223ad31c7.svg";
export { ForwardRef as ReactComponent };